export default class Snackbar {
    constructor() {
        this.snackbar = document.querySelector(".snackbar");
    }

    hide() {
        this.snackbar.classList.remove("show");
        this.snackbar.innerText = null;
    }

    show(message, status = "success") {
        if (this.snackbar) {
            this.snackbar.innerText = message;
            this.snackbar.classList.add("show");
            if (status === "error") {
                this.snackbar.classList.add("error");
            } else {
                this.snackbar.classList.remove("error");
            }
            setTimeout(this.hide.bind(this), 4000);
        }
    }
}
